<his-plam [label]="setting().label | hisUi"
          [helptext]="setting().helptext | hisUi" [required]="setting().required"
          [title]="title()">
    <his-multiselect #content [(ngModel)]="selectedItems"
                     [customOptionsMethod]="getAllOptions.bind(this)"
                     [removeSelectedOptionsFromDropdown]="true"></his-multiselect>
</his-plam>
